import { IUserHasUserGroup } from './IUserHasUserGroup';

export interface IUserGroup {
  idUserGroup: number;
  UserGroup: string;
  Email: string | null;
  PhoneNumber: string | null;
  NotifcationOptionBitmask: number | undefined;
  /**
   * Vom System bereitgestellte Gruppe. Ihre Mitglieder lassen sich pflegen,
   * Name und Zweck aber nicht — und als normale Gruppe (Vorgang, Aufgabe,
   * Maßnahme, Zuständigkeit) ist sie nicht zuweisbar.
   */
  isSystemGroup?: boolean | number;
  /**
   * Unveränderlicher technischer Schlüssel einer Systemgruppe, z. B. `gwg`.
   * Die Logik greift ausschließlich hierüber auf die Gruppe zu, nie über den
   * Namen. Bei normalen Gruppen `null`.
   */
  SystemKey?: string | null;
  /** #1256: Signatur des Gruppenpostfachs (HTML, serverseitig sanitisiert). */
  Signature?: string | null;
}

export interface IUserGroupFullObject extends IUserGroup {
  UserHasUserGroupArray: IUserHasUserGroup[];
}

/** Technische Schlüssel der bekannten Systemgruppen. */
export const SYSTEM_KEY_GWG = 'gwg';

/**
 * Ist die Gruppe eine Systemgruppe?
 *
 * Bewusst über die Wahrheitswertigkeit und nicht über `=== true`: die Spalte
 * ist ein TINYINT und kommt als `1`/`0` aus dem Backend.
 */
export const isSystemUserGroup = (userGroup: IUserGroup): boolean =>
  Boolean(userGroup.isSystemGroup);

/**
 * Gruppen, die als normale Benutzergruppe auswählbar sind — Systemgruppen
 * gehören in kein Auswahlfeld für Vorgänge, Aufgaben, Maßnahmen,
 * Zuständigkeiten oder Tickets.
 *
 * Für Anzeigezwecke (einen bereits gespeicherten Gruppennamen auflösen) ist
 * weiterhin die ungefilterte Liste zu verwenden.
 */
export const selectableUserGroups = (
  userGroupArray: IUserGroup[] | undefined
): IUserGroup[] =>
  (userGroupArray ?? []).filter(userGroup => !isSystemUserGroup(userGroup));
